<ng-container *ngIf="isAuthenticated; else publicLanding">
  <div class="layout" [class.sidebar-open]="sidebarOpen">
    <app-sidebar [isSidebarOpen]="sidebarOpen" (toggle)="toggleSidebar()"></app-sidebar>

    <div class="content">
      <app-navbar (toggle)="toggleSidebar()"></app-navbar>

      <div class="container py-5">

      </div>

      <router-outlet></router-outlet>

    </div>
  </div>
</ng-container>

<ng-template #publicLanding>
  <app-navbar></app-navbar>

  <main class="landing container py-5">
    <router-outlet></router-outlet>

  </main>
</ng-template>

<!-- Modal: sesión por expirar -->
<app-modal
  *ngIf="mostrarModalInactividad"
  titulo="Sesión por expirar"
  [mostrar]="mostrarModalInactividad"
  [loading]="prolongandoSesion"
  labelBtnAceptar="Mantener sesión"
  labelBtnCerrar="Cerrar sesión"
  (aceptar)="prolongarSesion()"
  (cerrado)="cerrarSesion()"
>
  <p>Su sesión está por expirar por inactividad. ¿Desea mantenerla o cerrar sesión?</p>
</app-modal>

<!-- Modal bloqueante: sesión caducada detectada por el backend -->
<app-modal
  *ngIf="sesionCaducada"
  titulo="Sesión caducada"
  [mostrar]="sesionCaducada"
  labelBtnAceptar="Volver a ingresar"
  [btnCerrar]="false"
  (aceptar)="cerrarSesion()"
>
  <p>Su sesión ha expirado. Por favor vuelva a iniciar sesión con Clave Única.</p>
</app-modal>
